import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Installation profile layer kind.
 *
 * - `base`: deterministic baseline derived from installation context
 * - `chosen`: human-authored overrides on top of the base
 *
 * @since 1.0.0
 */
export const InstallationProfileLayerKind = Schema.Literal("base", "chosen");
export type InstallationProfileLayerKind = Schema.Schema.Type<typeof InstallationProfileLayerKind>;

/**
 * InstallationProfileLayer model.
 *
 * One row per (installation, kind) layer of the InstallationProfile.
 * `data` is an opaque JSONB document; the renderer schema is layered on
 * later — keep `Schema.Unknown` here so this table stays a passive store.
 *
 * @since 1.0.0
 */
export class InstallationProfileLayer extends Model.Class<InstallationProfileLayer>("InstallationProfileLayer")({
  id: Model.Generated(Schema.String),
  installationId: Schema.String,
  kind: InstallationProfileLayerKind,
  data: Schema.Unknown,
  version: Schema.Number,
  authorId: Schema.NullOr(Schema.String),
  createdAt: Model.DateTimeInsertFromDate,
  updatedAt: Model.DateTimeUpdateFromDate,
}) {}
